<template>
  <van-popup :value="value" @input="input" round>
    <div class="vertical items-center verify-captcha">
      <div class="horizontal items-center">
        <van-image :src="captchaImage" show-loading>
          <template #loading>
            <van-loading type="spinner" size="24"/>
          </template>
        </van-image>
        <div class="change" @click="change">Change</div>
      </div>

      <van-form ref="captchaForm" @submit="onRightClick">
        <van-field
            :rules="[{ validator:captchaValidator}]" class="captcha" v-model="captchaValue" maxlength="4"
            placeholder="Verification Code"/>

        <div class="flex flex-row items-center  mt-5  w-full gap-3 text-center">
          <div class="left-btn flex-1 radius-border" @click="onLeftClick">Cancel</div>
          <van-button class="right-btn flex-1" native-type="submit">Apply</van-button>
        </div>
      </van-form>

    </div>

  </van-popup>
</template>

<script>
import user from "@/api/user";

export default {
  name: "PopupCaptcha",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    captcha: {
      type: String,
      default: ""
    },
    captchaImage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {
    captchaValue: {
      get() {
        return this.captcha;
      },
      set(val) {
        this.$emit(`onCaptchaChange`, val);
      }
    }

  },
  watch: {
    async value(v) {
      if (v) {
        this.change();
      }else {
        this.$emit(`onCaptchaChange`, '');
      }
    }

  },
  methods: {
    captchaValidator() {
      if (this.captcha === "") {
        return false;
      }
      if (this.captcha.length !== 4) {
        return false;
      }
      return true;
    },
    input(e) {
      this.$emit("input", e);
    },
    change() {
      this.$emit("change");
    },
    onLeftClick() {
      this.$emit("input", false);
    },
    onRightClick() {
      this.$emit("onRightClick", this.captcha);
    }
  }
};
</script>


<style scoped lang="less">
.verify-captcha {
  padding: 16px;
  color: #979797;
  font-size: 14px;
}

::v-deep .van-cell {
  padding: 0
}

::v-deep .van-button--normal {
  padding: 0;
}

.captcha {
  margin-top: 20px;
  border-radius: 20px;
  font-size: 14px;
  width: 240px;
  color: #333333;
  border: 1px solid #D8D8D8;
}

input,
input::placeholder {
  font-size: 14px;
  font-weight: lighter;
  padding: 0 !important;
}

.change {
  margin-left: 20px;
  border-bottom: 1px solid #979797;
}

.left-btn {
  border-color: #BEBEBE;
  color: #333333;
  height: 41px;
  line-height: 41px;
  border-radius: 20px;
}

.right-btn {
  background: #333333;
  color: white;
  height: 41px;
  line-height: 41px;
  border-radius: 20px;
}

</style>